export default {

  dbCon: '/cti_api/index.php/dbCon', // '/dbcon.php'
  load: '/cti_api/index.php/load', // '/load.php'
  dndOff: '/cti_api/index.php/dndOff', // '/data1.php'
  dndOn: '/cti_api/index.php/dndOn', // '/data.php'
  transfer: '/cti_api/index.php/transfer', // '/transfer/transfer.php'
  unTransfer: '/cti_api/index.php/unTransfer', // '/transfer/untransfer.php'
  checkTransfer: '/cti_api/index.php/checkTransfer', // '/transfer/check_transfer.php'
  dial: '/cti_api/index.php/dial', // '/clicktocall/originate.php'
  blindTransfer: '/cti_api/index.php/blindTransfer', // '/transfer/blind_transfer.php'
  attendedTransfer: '/cti_api/index.php/attendedTransfer', // '/transfer/attended_transfer.php'
  listen: '/cti_api/index.php/listen', // '/whisper/listen_only.php'
  whisper: '/cti_api/index.php/whisper', // '/whisper/listen_whisper.php'
  hangup: '/cti_api/index.php/hangup', // '/hangup/hangup.php'
  playSound: '/playsound/sound.php',
  answer: '/cti_api/index.php/answer', // '/answer/answer.php'
  queueReset: '/cti_api/index.php/queueReset', // '/queue_reset.php',
  customDial: '/clicktocall/click_ziotes.php',
  hangupCustomDial: '/hangup/hangup.php',
  getChannel: '/clicktocall/get_channel.php',
  hangupWithChannel: '/hangup/hangup-with-channel.php',
  updateExtension: '/v1/users/save-extensions',
  oneTouchRecording: '/one-touch-recording/otr.php'
}
